{
  "internalPortal": {
    "components": {
      "work": {
        "title": "Work",
        "subtitle": "Track day-to-day execution activities for this organization.",
        "subTabs": {
          "tickets": "Tickets",
          "tasks": "Tasks",
          "actionItems": "Action Items"
        },
        "actionItems": {
          "title": "Action Items",
          "table": {
            "columns": {
              "complete": "Complete"
            }
          },
          "actions": {
            "new": "New Action Item"
          },
          "details": {
            "openFile": "Open"
          },
          "noData": {
            "withoutFilters": {
              "title": "No action items found",
              "description": "No action items found for this view."
            }
          }
        },
        "tickets": {
          "actions": {
            "new": "New Ticket"
          },
          "table": {
            "columns": {
              "ticket": "Ticket #",
              "subject": "Subject"
            }
          },
          "noData": {
            "withoutFilters": {
              "title": "No tickets found",
              "description": "No tickets found for this view."
            }
          }
        },
        "tasks": {
          "table": {
            "columns": {
              "source": "Source"
            }
          }
        }
      }
    }
  }
}
